<template>
  <div>
    <span v-if="data.column.field === 'property'">
      {{ data.row[data.column.field] }}
    </span>
    <span v-else-if="data.column.field === 'ctr'">
      {{ data.row[data.column.field] | formatValue }} %
    </span>
    <span v-else-if="data.column.field === 'viewsProfit' || data.column.field === 'clicksProfit' || data.column.field === 'actionsProfit'|| data.column.field === 'impressionsProfit'">
      {{ data.row[data.column.field] | formatValue }} {{ $currencySymbol }}
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] | formatValue }}
    </span>
  </div>
</template>

<script>
export default {
  filters: {
    formatValue(amount) {
      const amt = Number(amount)
      // eslint-disable-next-line no-mixed-operators
      return amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 }) || '0'
    },
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
}
</script>
